export default function Flag() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="flag">
                <path
                    id="Icon"
                    d="M3.33203 10.8333H16.3212C16.7066 10.8333 16.8993 10.8333 17.0094 10.7525C17.1054 10.682 17.1666 10.5739 17.1777 10.4553C17.1903 10.3194 17.0912 10.1541 16.8929 9.82367L15.2045 7.00966C15.1297 6.88496 15.0923 6.8226 15.0776 6.75604C15.0647 6.69716 15.0647 6.63618 15.0776 6.5773C15.0923 6.51073 15.1297 6.44838 15.2045 6.32367L16.8929 3.50966C17.0912 3.17919 17.1903 3.01395 17.1777 2.878C17.1666 2.75945 17.1054 2.65129 17.0094 2.58082C16.8993 2.5 16.7066 2.5 16.3212 2.5H3.33203L3.33203 17.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}
